import styled from "styled-components";

export const Input = styled.input`
  width: 70px;
  height: 20px;
  border: 1px solid #3e3d3f;
  border-radius: 3px;
  transition: all 0.5s;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  background: white;
  -moz-appearance: none;
  @media (max-width: 1366px) {
    width: 55px;
    height: 14px;
  }
`;
